import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="transparent" {...props}>
    <path
      d="M25.6368 15.1912L26.1672 14.6609V14.6609L25.6368 15.1912ZM16.9364 26.1259V26.8759C17.1353 26.8759 17.3261 26.7969 17.4667 26.6563L16.9364 26.1259ZM14.7246 26.1259H13.9746C13.9746 26.5401 14.3104 26.8759 14.7246 26.8759V26.1259ZM14.7246 23.8692L14.1943 23.3389C14.0536 23.4795 13.9746 23.6703 13.9746 23.8692H14.7246ZM23.9329 15.7216C24.257 15.3975 24.7824 15.3975 25.1065 15.7216L26.1672 14.6609C25.2573 13.751 23.7821 13.751 22.8723 14.6609L23.9329 15.7216ZM25.1065 15.7216C25.4306 16.0457 25.4306 16.5711 25.1065 16.8952L26.1672 17.9558C27.077 17.046 27.077 15.5708 26.1672 14.6609L25.1065 15.7216ZM25.1065 16.8952L16.4061 25.5956L17.4667 26.6563L26.1672 17.9558L25.1065 16.8952ZM16.9364 25.3759H14.7246V26.8759H16.9364V25.3759ZM22.8723 14.6609L14.1943 23.3389L15.2549 24.3995L23.9329 15.7216L22.8723 14.6609ZM13.9746 23.8692V26.1259H15.4746V23.8692H13.9746ZM21.9243 16.6695L24.1586 18.9038L25.2193 17.8431L22.985 15.6088L21.9243 16.6695Z"
      fill="currentColor"
    />

    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path
        d="M22.5801 12.832L22.5801 8.4987C22.5801 7.30208 21.61 6.33203 20.4134 6.33203L8.49674 6.33203C7.30013 6.33203 6.33008 7.30208 6.33008 8.4987L6.33008 21.4987C6.33008 22.6953 7.30013 23.6654 8.49674 23.6654L12.7467 23.6654"
        strokeWidth="2"
      />
      <path d="M11.75 11.75H17.25" />
      <path d="M11.75 15H17.25" />
      <path d="M11.75 18.25H15" />
    </g>
  </svg>
);
